import {reduce} from 'lodash'
import {Basic, Ventrata} from 'types'

export const convertUnitCounterMapToRequestUnitItems = (map: Basic.UnitCounterMap): Ventrata.RequestUnitItem[] => {
  return reduce(
    map,
    (result: Ventrata.RequestUnitItem[], quantity, unitId) => {
      for (let i = 0; i < quantity; i++) {
        result.push({unitId})
      }

      return result
    },
    []
  )
}
